<template>
	<div class="content">
		<div class="md-layout">
			<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>

			<div class="md-layout-item md-small-size-100 md-medium-size-50 md-size-50">

				<md-card>
					<md-card-content>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100 text-center">
								<h4 style="color: #FFF">មិនមានទំព័រនេះទេ។</h4>
							</div>
						</div>
					</md-card-content>
				</md-card>
			</div>

			<div class="md-layout-item md-small-size-100 md-medium-size-25 md-size-25"></div>
		</div>
	</div>

</template>

<script>
	export default {
		created() {
		},

		data() {
			return {
			}
		},
		methods: {
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/404.vue